import { Component, OnInit, inject } from '@angular/core';
import { Router } from '@angular/router';
import {
  FormBuilder,
  FormGroup,
  FormControl,
  ReactiveFormsModule,
} from '@angular/forms';
import { MatTableDataSource } from '@angular/material/table';
import { MatNativeDateModule, MatOptionModule } from '@angular/material/core';
import { MatSelectModule } from '@angular/material/select';
import { MatFormFieldModule } from '@angular/material/form-field';
import { MatButtonModule } from '@angular/material/button';
import { TitleComponent } from '@shared/components/title/title.component';
import { MatCardModule } from '@angular/material/card';

@Component({
  templateUrl: './detail-page.component.html',
  styles: [],
  standalone: true,
  imports: [
    MatCardModule,
    TitleComponent,
    ReactiveFormsModule,
    MatButtonModule,
    MatFormFieldModule,
    MatSelectModule,
    MatOptionModule,
    MatNativeDateModule
  ],
})
export class DetailPageComponent implements OnInit {
  // para seleccionar los items
  disableSelect = new FormControl(false);

  private router = inject(Router);

  private formBuilder = inject(FormBuilder);

  formDetail!: FormGroup;

  dataSource: MatTableDataSource<string>;
  constructor() {
    this.dataSource = new MatTableDataSource();
    this.buildForm();
  }

  ngOnInit(): void {}

  goBack(): void {
    this.router.navigateByUrl('/admin/reservations/create-reservations');
  }

  private buildForm() {
    this.formDetail = this.formBuilder.group({
      available: [''],
      reserved: [''],
    });
  }
}
